import styled from '@emotion/styled';

export const CUSTOMER_DISPLAY_FOOTER_HEIGHT = '80px';

export const Container = styled.div`
    width: 100%;
    height: ${CUSTOMER_DISPLAY_FOOTER_HEIGHT};
    background-color: #646464;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

export const RestaurantName = styled.h1`
    color: ${({ theme }) => theme.color.white};
    font-size: ${({ theme }) => theme.size.textLarge};
    ${({ theme }) => theme.font.familySemiBold};
    margin: 0;
    text-transform: uppercase;
`;
